import styled from 'styled-components';
import {device} from '../../../styled/device';

export const StyledHeader = styled.div<{onlyForDesktop?: boolean}>`
  position: relative;
  z-index: 10;
  padding: 24px 0;
  display: flex;
  align-items: center;

  @media (max-width: ${device.tablet}) {
    display: ${props => (props.onlyForDesktop ? 'none' : 'flex')};
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  row-gap: 15px;
  column-gap: 50px;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 80px;

  @media (max-width: ${device.tablet}) {
    column-gap: 25px;
  }

  @media (max-width: ${device.mobileXL}) {
    padding: 0 10px;
    column-gap: 10px;
  }
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  word-break: break-word;

  img {
    height: 46px;
  }

  .logoName {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -moz-box;
    -moz-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-clamp: 2;
    box-orient: vertical;

    font-size: 24px;
    color: #161643;
    font-weight: 700;
    margin-left: 5px;
  }

  @media (max-width: ${device.mobileXL}) {
    position: relative;
    z-index: 15;
    margin-right: auto;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 50px;

  .link {
    font-size: 14px;
    font-weight: 500;
    color: #6b6b95;
    transition: color 0.2s;

    &:hover,
    &.active {
      color: #23262f;
    }
  }

  .user,
  .login {
    width: 40px;
    height: 40px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: #e6e8ec;
  }

  @media (max-width: ${device.laptop}) {
    gap: 0;
  }
`;
